/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBolt = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m13.468 2.02.003-.02-3.11 5.653.003.002-1.551 2.816H8.81l-1.807 3.283h.002l-.006.01h2.904l1.213.005L9.941 22l3.67-5.81h-.001l.841-1.331.002-.003L17 10.828h-.003l.003-.005h-3.975v.002h-.732l1.178-8.81z" /></svg>;
export default SvgBolt;